<template>
  <div class="bg-pattern-gray add-edit-page-container">
    <div class="-content d-flex align-items-start flex-column">
      <div class="page-global-header px-0 mt-3 w-100">
        
      </div>

      <div class="page-body w-100">
        <div class="row mx-0">
          <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 mx-auto">
            <div class="row mx-0 d-flex justify-content-between align-items-center mb-4">
              <div class="col-6">
                <button class="btn btn-lauren-green btn-sm">
                  <i class="fas fa-tools me-2"></i> Add Item
                </button>
              </div>
              <div class="col-6 d-flex justify-content-end">
                <button class="btn btn-white">Item No: {{ currentItemNo }}</button>
              </div>
            </div>
            <AddItem ref="addItemForm"></AddItem>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AddItem from "./AddItem.vue";

export default {
  name: "AddListItem",
  components: {
    AddItem
  },
  data() {
    return {
      loadingInstance: null,
      isLoading: false,
      loadingText: "Loading...",
      listAddedItemNumber: []
    }
  },
  created() {
    this.setAddedItemNumber();
    this.listAddedItemNumber = this.$store.getters['item/get_item_added_recently'];
  },
  computed: {
    calculateTotal() {
      // this.$store.commit('item/clearRecentItemsAddPage')
      const items = this.$store.getters['item/get_item_added_recently'] || [];
      // console.log(items)
      if (items.length == 0) {
        return 0.00;
      }
      const total = items.reduce((accumulator, item) => {
        return accumulator + (item.quantity * item.unit_price);
      }, 0);
      return total;
    },
    listOfAddedItems() {
      return this.listAddedItemNumber;
    },
    currentItemNo() {
      return this.$store.getters['item/get_item_number_generated'] || localStorage.getItem("item_number_generated") || "";
    }
  },
  beforeRouteLeave(to, from, next) {
    // Check if the route is changing
    if (to.path !== from.path) {
      // Call the mutation to clear the state
      this.$store.commit('item/clearRecentItemsAddPage');
    }
    next();
  },
  methods: {
    setAddedItemNumber() {
      this.listAddedItemNumber = this.$store.getters['item/get_item_added_recently'] || [];
    },
    removeItemFromRecentList(itemNoToRemove) {
      this.$store.commit('item/removeItemFromRecentList', itemNoToRemove);
      this.setAddedItemNumber();
    }
  }
};
</script>